// extracted by mini-css-extract-plugin
export var archiveGrid = "livres-module--archiveGrid--Jsl0X";
export var closing = "livres-module--closing--hhpJE";
export var closingEyebrow = "livres-module--closingEyebrow--Rly3k";
export var library = "livres-module--library--flBmb";
export var libraryGrid = "livres-module--libraryGrid--oy5F0";
export var libraryHeading = "livres-module--libraryHeading--HuB4N";
export var miniBook = "livres-module--miniBook--Z6nxJ";
export var miniBookVisual = "livres-module--miniBookVisual--7Wdy8";
export var page = "livres-module--page--SAuKQ";
export var reveal = "livres-module--reveal--GQj-3";
export var revealVisible = "livres-module--revealVisible--m4fEB";